import { types as sdkTypes } from '../util/sdkLoader';

const { LatLng, LatLngBounds } = sdkTypes;

// An array of locations to show in the LocationAutocompleteInput when
// the input is in focus but the user hasn't typed in any search yet.
//
// Each item in the array should be an object with a unique `id` (String) and a
// `predictionPlace` (util.types.place) properties.
//
// NOTE: these are highly recommended, since they
//       1) help customers to find relevant locations, and
//       2) reduce the cost of using map providers geocoding API
const defaultLocations = [
  {
    id: 'default-san-francisco',
    predictionPlace: {
      address: 'San Francisco, California, United States',
      bounds: new LatLngBounds(
        new LatLng(37.8100, -122.3870),  // northeast
        new LatLng(37.7500, -122.4513), // southwest
      ),
      origin: {
        lat: 37.7749,
        lng: -122.4194,
      },
    },
  },
  // East Bay — Alameda County
  {
    id: 'default-oakland',
    predictionPlace: {
      address: 'Oakland, California, United States',
      bounds: new LatLngBounds(
        new LatLng(37.8850, -122.1140),  // northeast
        new LatLng(37.7000, -122.3550),  // southwest
      ),
      origin: {
        lat: 37.8044,
        lng: -122.2712,
      },
    },
  },
  {
    id: 'default-berkeley',
    predictionPlace: {
      address: 'Berkeley, California, United States',
      bounds: new LatLngBounds(
        new LatLng(37.9060, -122.2340),  // northeast
        new LatLng(37.8350, -122.3270),  // southwest
      ),
      origin: {
        lat: 37.8715,
        lng: -122.2730,
      },
    },
  },
  {
    id: 'default-fremont',
    predictionPlace: {
      address: 'Fremont, California, United States',
      bounds: new LatLngBounds(
        new LatLng(37.6100, -121.8900),  // northeast
        new LatLng(37.4500, -122.0700),  // southwest
      ),
      origin: {
        lat: 37.5485,
        lng: -121.9886,
      },
    },
  },
  // East Bay — Contra Costa County
  {
    id: 'default-walnut-creek',
    predictionPlace: {
      address: 'Walnut Creek, California, United States',
      bounds: new LatLngBounds(
        new LatLng(37.9500, -121.9900),  // northeast
        new LatLng(37.8600, -122.1200),  // southwest
      ),
      origin: {
        lat: 37.9101,
        lng: -122.0652,
      },
    },
  },
  {
    id: 'default-concord',
    predictionPlace: {
      address: 'Concord, California, United States',
      bounds: new LatLngBounds(
        new LatLng(38.0400, -121.9500),  // northeast
        new LatLng(37.9200, -122.0900),  // southwest
      ),
      origin: {
        lat: 37.9780,
        lng: -122.0311,
      },
    },
  },
  {
    id: 'default-san-ramon',
    predictionPlace: {
      address: 'San Ramon, California, United States',
      bounds: new LatLngBounds(
        new LatLng(37.8300, -121.9100),  // northeast
        new LatLng(37.7200, -122.0300),  // southwest
      ),
      origin: {
        lat: 37.7799,
        lng: -121.9780,
      },
    },
  },
  // {
  //   id: 'default-helsinki',
  //   predictionPlace: {
  //     address: 'Helsinki, Finland',
  //     bounds: new LatLngBounds(new LatLng(60.29783, 25.25448), new LatLng(59.92248, 24.78287)),
  //   },
  // },
  // {
  //   id: 'default-turku',
  //   predictionPlace: {
  //     address: 'Turku, Finland',
  //     bounds: new LatLngBounds(new LatLng(60.53045, 22.38197), new LatLng(60.33361, 22.06644)),
  //   },
  // },
  // {
  //   id: 'default-tampere',
  //   predictionPlace: {
  //     address: 'Tampere, Finland',
  //     bounds: new LatLngBounds(new LatLng(61.83657, 24.11838), new LatLng(61.42728, 23.5422)),
  //   },
  // },
  // {
  //   id: 'default-oulu',
  //   predictionPlace: {
  //     address: 'Oulu, Finland',
  //     bounds: new LatLngBounds(new LatLng(65.56434, 26.77069), new LatLng(64.8443, 24.11494)),
  //   },
  // },
  // {
  //   id: 'default-ruka',
  //   predictionPlace: {
  //     address: 'Ruka, Finland',
  //     bounds: new LatLngBounds(new LatLng(66.16997, 29.16773), new LatLng(66.16095, 29.13572)),
  //   },
  // },
];
export default defaultLocations;
